import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, FormField, List, Popover, RadioGroup, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAccountOutline, mdiCellphoneBasic, mdiLocationEnter, mdiLocationExit, mdiMenuLeft, mdiMenuRight, mdiTrophyOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import { addYears, format, parse } from 'date-fns';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatPhone, getCookie, getUrlVersion, getUser, setData, setLoading } from '../../../../commons/functions';

type ItemUserShift = {
  idUser: number,
  order: number,
  orden: number,
  displayName: string,
  dateGroup: string
}


export const MembersMercenariesPaxPage = () => {

  const { idUser, menu, data } = useGlobalState();

  useGlobalState();


  const [movements, setMovements] = useState<ItemsMovement[]>([]);
  const [users, setUsers] = useState<ItemUserShift[]>([]);
  const [filter, setFilter] = useState<string>('0');

  const handleGetMercenaryUsers = async () => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/mercenaries/pax/users',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({}),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(dataWeb, setData);
      if (dataWeb.code == 0) {
        setUsers(dataWeb.users);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }


  }
  const handleRegisterMercenary = async (add: boolean, idMovement: number) => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/mercenaries/pax/subscribe',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(
          {
            idMovement: idMovement,
            add: add,
            columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName, idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, voucherStage",
            idAccountPlan: 83024,
            isPax: true,
            isSelling: true,
            dateStart: format(addYears(new Date(), -5), 'dd-MM-yyyy'),
            orderBy: "dateTransaction",
            order: "desc",
          }
        ),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(dataWeb, setData);
      if (dataWeb.code == 0) {
        setMovements(dataWeb.movements);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }


  }
  const handleGetMovements = async () => {
    //if (parameters.startDate && parameters.endDate) { 

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/movements/pax/list',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(
          {
            columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName, idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, voucherStage",
            idAccountPlan: 83024,
            isPax: true,
            isSelling: true,
            dateStart: format(addYears(new Date(), -5), 'dd-MM-yyyy'),
            orderBy: "dateTransaction",
            order: "desc",
          }
        ),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(dataWeb, setData);
      if (dataWeb.code == 0) {

        const sortedMovements = [...dataWeb.movements].sort((a, b) => {
          // Helper to convert "06-04-2026 16:01" to a Date object
          const parseDate = (dateStr: string | undefined): Date => {
            if (!dateStr) return new Date(0);
            const [day, month, year, time] = dateStr.split(/[- ]/);
            const [hours, minutes] = time.split(':');
            // Note: Month is 0-indexed in JS (January is 0)
            return new Date(
              parseInt(year),
              parseInt(month) - 1,
              parseInt(day),
              parseInt(hours),
              parseInt(minutes)
            );
          };

          const dateA = parseDate(a.jsonMovement?.dateEndSell);
          const dateB = parseDate(b.jsonMovement?.dateEndSell);

          // For Descending order (Newest first)
          return +dateB - +dateA;
        });
        setMovements(sortedMovements);

      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }

  }
  const filteredMovements = movements.filter((item) => {
    if (filter === '1') {
      return item.voucherStage === 1;
    } else if (filter === '2') {
      return item.voucherStage === 2 && item.jsonMovement.idUser === idUser;
    } else {
      return true;
    }
  });
  useEffect(() => {
    handleGetMovements()
  }, []);
  const showRegisterColumn = filteredMovements.some(s => s.voucherStage === 1);
  const showBookingButton = filteredMovements.some(s => s.voucherStage === 2 && s.jsonMovement.idUser === idUser && s.jsonMovement.idBooking === 0);

  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">

          <Header variant="h1" actions={<SpaceBetween direction='horizontal' size='xs'>
            {users?.length === 0 ? <Button onClick={() => handleGetMercenaryUsers()}>Ver usuarios</Button> : <Button onClick={() => {
              setUsers([])
              setMovements([])
              handleGetMovements()
            }}>Ver PAX</Button>}
            <Favorites /></SpaceBetween>}>PAXs</Header>

          {users?.length > 0 && (
            <Table

              sortingDisabled
              columnDefinitions={[
                {
                  id: 'order',
                  header: '',
                  cell: (item) => <Box textAlign='center'>{item.idUser === idUser ? <BadgeCustom color='blue' size='large'><Icon path={mdiMenuRight} size={1} /> {item.orden} <Icon path={mdiMenuLeft} size={1} /></BadgeCustom> : item.orden}</Box>,
                  width: 70,
                },
                {
                  id: 'displayName',
                  header: 'Usuario',
                  cell: (item) => item.idUser === idUser ? <strong>{item.displayName}</strong> : item.displayName,
                },
                {
                  id: 'dateGroup',
                  header: 'Última postulación',
                  cell: (item) => item.dateGroup,
                  width: 120,
                },
              ]}
              items={users}
              stickyHeader
              variant="embedded"
            />

          )}
          {movements && users?.length === 0 && (
            <Table

              filter={
                <RadioGroup
                  direction='horizontal'
                  items={[{ label: 'Todos', value: '0' }, { label: 'En venta', value: '1' }, { label: 'Mis PAX', value: '2' }]}
                  value={filter}
                  onChange={(event) => {
                    setFilter(event.detail.value);
                  }}
                />
              }
              sortingDisabled
              cellVerticalAlign='top'
              columnDefinitions={[
                {
                  id: 'dateTransaction',
                  header: 'Fecha',
                  minWidth: 100,
                  cell: (item) => <FormField label={format(parse(item.jsonMovement.dateProgram, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}>
                    {format(parse(item.jsonMovement.dateProgram, "dd-MM-yyyy HH:mm", new Date()), "HH:mm")}

                  </FormField>,
                  sortingField: 'dateTransaction',
                },
                {
                  id: 'PAX',
                  header: 'PAX',
                  minWidth: 200,
                  cell: (item) => <FormField label={item.jsonMovement.nombre}>
                    <Icon path={mdiCellphoneBasic} size={1} /> {formatPhone(item.jsonMovement.movil)}
                  </FormField>,
                  sortingField: 'isSelling',
                },
                {
                  id: 'adjudicado',
                  header: 'Adjudicación',
                  minWidth: 180,
                  cell: (item) => <FormField label={item.jsonMovement.stage === 1 ? '- - - - - - - - - ' : getUser(item.jsonMovement.idUser, data).displayName}>

                    {item.voucherStage === 1 ? 'Finaliza el ' : 'Finalizó el '} {item.jsonMovement.dateEndSell}
                  </FormField>,
                  sortingField: 'isSelling',
                },
                {
                  id: 'userDirector',
                  header: 'Status',
                  cell: (item) =>
                    item.voucherStage === 1 && item.isAuction ? <BadgeCustom color="yellow">En remate</BadgeCustom> :
                      item.voucherStage === 1 ? <BadgeCustom color='lime'>En venta</BadgeCustom> : item.voucherStage >= 2 ?

                        <BadgeCustom color='green'>Vendido</BadgeCustom> : <BadgeCustom color='violet'>Realizado</BadgeCustom>,
                  sortingField: 'isSelling',
                },
                {
                  id: 'mercenaries',
                  header: '',
                  cell: (item) => item.jsonMovement.mercenaries.length === 0 ? '---' : (
                    <Popover dismissButton={false} triggerType="custom"
                      header="Postulantes"
                      content={
                        <List
                          ariaLabel="Lista de mercenarios"
                          items={item.jsonMovement.mercenaries.map((mercenary: any, index: number) => ({
                            id: String(mercenary.idUser),
                            content:
                              <React.Fragment key={mercenary.idUser}>
                                {
                                  // 2. Correctly use the ternary operator syntax
                                  mercenary.won === 1 ? (
                                    <SpaceBetween size='xs' direction='horizontal'>
                                      {/* Note: Keys are not needed on children of SpaceBetween here unless dynamic */}
                                      <Icon path={mdiTrophyOutline} size={0.75} />
                                      <span>{mercenary.displayName}</span>
                                    </SpaceBetween>
                                  ) : (
                                    // 3. FIX: Wrap the plain string in a keyed element (like a span)
                                    <span key={`name-${mercenary.idUser}`}>
                                      {mercenary.displayName}
                                    </span>
                                  )
                                }
                              </React.Fragment>
                          }))}
                          renderItem={(merc) => merc}
                        />
                      }
                    >
                      <Icon path={mdiAccountOutline} size={1} />x{item.jsonMovement.mercenaries.length}
                    </Popover>
                  ),
                  sortingField: 'isSelling',
                  minWidth: 80,
                },

                ...(showRegisterColumn || showBookingButton
                  ? [{
                    id: 'register',
                    header: '',
                    minWidth: showBookingButton ? 150 : 70,
                    cell: (item: any) =>
                      item.voucherStage === 1 ? (
                        item.jsonMovement.mercenaries.some((m: any) => m.idUser === idUser) ? (
                          <Button onClick={() => handleRegisterMercenary(false, item.idMovement)}>
                            <Icon path={mdiLocationExit} size={1} />
                          </Button>
                        ) : (
                          <Button
                            variant="primary"
                            onClick={() => handleRegisterMercenary(true, item.idMovement)}
                          >
                            {<Icon path={mdiLocationEnter} size={1} />}
                          </Button>
                        )
                      ) : showBookingButton && item.voucherStage === 2 && item.jsonMovement.idBooking === 0 && item.jsonMovement.idUser === idUser ? (
                        <Button fullWidth variant='primary' onClick={() => window.location.hash = `#members/mercenaries/book?m=${item.idMovement}`}>Reservar</Button>
                      ) : ('')
                  }]
                  : []),

              ]}
              items={filteredMovements}
              stickyHeader
              variant="embedded"
              empty={
                < Box
                  margin={{ vertical: "xs" }}
                  textAlign="center"
                  color="inherit"
                > No hay PAXs disponibles
                </Box >
              }
            />
          )}
        </SpaceBetween >
      }
    />
  );
};
